import { Box } from '@chakra-ui/react';

import { Condition } from 'Component/others';
import { TextMedium, TextRegular } from 'UiKit/typography';

import { SkeletonHead } from 'View/reschedule-form/component/skeleton';

import styles from './styles.module.css';

const Head = ({ scheduleDetail, isLoadingScheduleDetail }) => {
  return (
    <Box className={styles['reschedule-head__title-box']}>
      <Condition statement={!isLoadingScheduleDetail} fallback={<SkeletonHead />}>
        <TextMedium className={styles['reschedule-head__schedule-name']}>{scheduleDetail?.title}</TextMedium>
        <TextRegular className={styles['reschedule-head__schedule-date']}>{scheduleDetail?.datetime}</TextRegular>
      </Condition>
    </Box>
  );
};

export default Head;
